import { render, staticRenderFns } from "./moreOnlinePatient.vue?vue&type=template&id=35e1c9c5"
import script from "./moreOnlinePatient.vue?vue&type=script&lang=js"
export * from "./moreOnlinePatient.vue?vue&type=script&lang=js"
import style0 from "./moreOnlinePatient.vue?vue&type=style&index=0&id=35e1c9c5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports